module.exports = __webpack_public_path__ + "img/Uneven Seat.81989bc2.png";